import React, { createContext, useContext, useState, useCallback } from 'react';
import { Badge } from '@opendate-app/setlist';

const EventDemandContext = createContext({
  demandStatus: null,
  demandMultiplier: null,
  setDemand: () => {}
});

export const EventDemandProvider = ({ confirm, children }) => {
  const [demand, setDemandState] = useState({
    demandStatus: confirm?.demand_status ?? null,
    demandMultiplier: confirm?.demand_multiplier ?? null
  });

  const setDemand = useCallback(({ demandStatus, demandMultiplier }) => {
    setDemandState({
      demandStatus: demandStatus ?? null,
      demandMultiplier: demandMultiplier ?? null
    });
  }, []);

  return (
    <EventDemandContext.Provider value={{ ...demand, setDemand }}>
      {children}
    </EventDemandContext.Provider>
  );
};

export const useEventDemand = () => useContext(EventDemandContext);

export const DemandHotPill = () => {
  const { demandStatus, demandMultiplier } = useEventDemand();
  if (demandStatus !== 'hot') return null;
  return (
    <Badge color="orange" size="sm" title="Demand is running hot. Ticket velocity is well above the venue average.">
      <i className="fas fa-fire mr-1" />
      Hot{demandMultiplier ? ` · ${Number(demandMultiplier).toFixed(1)}×` : ''}
    </Badge>
  );
};

export default EventDemandContext;
